require('intersection-observer');
require('url-search-params-polyfill');
//import React from 'react';
//import ReactDOM from 'react-dom';
//import { hot } from 'react-hot-loader/root';
//import history from 'app/utils/history';
//import { store } from 'app';
import 'styles/tailwind.scss';
import 'styles/index.scss';
import processAnalyticsEvents from './EventManager';

/*const render = Component => {
  const HotComponent = hot(Component);
  ReactDOM.render(<HotComponent store={store} history={history} />, document.getElementById('react-root'));
};*/

if (SPA_MODE) {
  console.info('Running in Single Page Application mode.');
  //render(require('./Root').default);
} else {
  console.info('Running in Modular mode.');
  // include component loader at runtime in order to not interfere with HMR
  var createComponents = require('./react-component-loader').default;
  createComponents();
  processAnalyticsEvents();
}
